/**
 * Staff roster helpers (RMI-2026-707).
 *
 * "Available for dispatch" (profiles_v2.is_available_for_dispatch) is set from the profile editor, but the roster queries never loaded it,
 * so the assign-a-tech lists treated everyone as available. Every roster query now selects ROSTER_COLUMNS, and every list that OFFERS a tech
 * for assignment goes through assignableTechs(). Name lookups (a work order's current assignee, timeline text) keep using the full roster.
 */
export const ROSTER_COLUMNS = 'id, first_name, last_name, job_title, is_available_for_dispatch';

/** Only an explicit false removes someone; null / undefined / true stay assignable (the column defaults to true). */
export const isAssignable = (tech) => tech?.is_available_for_dispatch !== false;

/**
 * The people a dispatcher may pick. A work order's current assignee always stays in the list so the picker never goes blank
 * on a job that was assigned before the person was made unavailable.
 */
export const assignableTechs = (roster, currentId) =>
  (roster || []).filter((t) => isAssignable(t) || (currentId != null && currentId !== '' && t.id === currentId));

/**
 * Who may change a profile (RMI-2026-708). profiles_v2 has ONE update policy (Roster_Update_V4: auth_tier() >= 9) and a trigger that raises below tier 9.
 * For a lower-tier session PostgREST does not fail: the row is filtered out, zero rows change, and no error comes back. So "no error" is not "saved".
 */
export const MIN_TIER_TO_EDIT_PROFILES = 9;
export const canEditProfiles = (tier) => (Number(tier) || 0) >= MIN_TIER_TO_EDIT_PROFILES;

/** Reads a supabase update(...).select('id') result. -> null when a row really changed, otherwise the message to show the user. */
export const profileUpdateProblem = (result) => {
  const { data, error } = result || {};
  if (error) return error.message || 'The database returned an error.';
  if (!Array.isArray(data) || data.length === 0) {
    return 'The database refused the change, so nothing was saved. Changing a profile needs a tier 9 account (you may be signed in as a lower tier).';
  }
  return null;
};

